// Function to format a number with a space as a thousand separator
const FormatNumber = (number) => {
  if (number === undefined || number === null) {
      return "";  // Return an empty string or any default value you prefer for undefined or null inputs
  }

  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};

export default FormatNumber;